import { FunctionComponent } from 'react';
import { toast } from 'react-toastify';

import { Locales } from 'types/locale';

import { select as selectLocale } from 'utils/locale';

import Button, {
    ButtonElements,
    ButtonIconPositions,
    ButtonIconTypes,
    ButtonLayouts,
    ButtonSizes,
    ButtonStyles,
    ButtonTypes,
    ButtonVariants,
} from 'components/layout/Button';
import LayoutContainer from 'components/layout/LayoutContainer';
import ToastSuccessContainer from 'components/layout/ToastSuccessContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAboutSectionContact: FunctionComponent<Props> = ({
    translations: {
        title,
        subtitle,
        buttonProps,
    },
}) => {
    const translations = selectLocale({
        [Locales.Pl]: require('./locales/pl.json'),
    });

    const onCopyMail = (mailString: string): void => {
        try {
            navigator.clipboard.writeText(mailString).then(
                function () {
                    toast.success(
                        <ToastSuccessContainer text={translations?.copyEmail} />,
                        {
                            closeButton: false,
                        }
                    );
                },
                function () {
                    window.location.replace(`mailto:${mailString}`);
                }
            );
        } catch (error) {
            window.location.replace(`mailto:${mailString}`);
        }
    };

    return (
        <StyledComponent className="public-page-about-section-contact">
            <LayoutContainer>
                <div
                    className="subtitle"
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                />
                <div
                    className="title"
                    dangerouslySetInnerHTML={{ __html: title }}
                />
                <div className="button-wrapper">
                    {buttonProps.map((element) => (
                        <div
                            className="button"
                            key={element.buttonLabel}
                        >
                            <Button
                                type={ButtonTypes.Button}
                                element={ButtonElements.Anchor}
                                size={ButtonSizes.Medium}
                                style={ButtonStyles.Primary}
                                variant={ButtonVariants.Outline}
                                layout={ButtonLayouts.Wide}
                                onClick={() => {
                                    onCopyMail(element.buttonLabel);
                                }}
                                icon={{
                                    type: ButtonIconTypes.Image,
                                    position: ButtonIconPositions.Before,
                                    value: '/images/about/copy.svg',
                                }}
                            >
                                {element.buttonLabel}
                            </Button>
                        </div>
                    ))}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageAboutSectionContact;
